import { Compass, LineChart, Map, ShieldCheck } from "lucide-react";

const items = [
  { icon: Compass, title: "Identify high-ROI opportunities", desc: "Pinpoint where AI will create real, measurable business value across your operations." },
  { icon: ShieldCheck, title: "Assess organizational readiness", desc: "Understand data, workflow, and team gaps before investment, not after." },
  { icon: LineChart, title: "Quantify potential impact", desc: "Get a defensible view of ROI ranges, so leadership can prioritize with confidence." },
  { icon: Map, title: "Build a 90-day execution roadmap", desc: "Move from analysis to a sequenced plan with clear milestones and owners." },
];

const WhatItDoes = () => {
  return (
    <section id="what" className="bg-secondary/40 py-12 lg:py-14">
      <div className="container-tight">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="eyebrow">What Signal AI does</span>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              A clarity layer between AI ambition and AI investment.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-muted-foreground">
              Signal AI gives leadership teams the structured insight needed to commit capital with confidence not assumption.
            </p>
          </div>
          <div className="lg:col-span-7">
            <div className="grid gap-px overflow-hidden rounded-2xl border border-border bg-border sm:grid-cols-2">
              {items.map(({ icon: Icon, title, desc }) => (
                <div key={title} className="bg-card p-6">
                  <Icon className="h-5 w-5 text-signal" strokeWidth={1.75} />
                  <h3 className="mt-4 text-base font-semibold text-foreground">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 rounded-2xl border border-signal/20 bg-signal-soft/60 p-6">
          <p className="text-base text-foreground">
            Signal AI is designed as a <span className="font-medium">starting layer</span>, giving clarity before larger investments are made.
            <span className="ml-2 text-muted-foreground">Begin at <span className="font-semibold text-signal">$0</span>, decide next steps based on actual outcomes.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatItDoes;
